import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {Box,Tab,Tabs,Button,Typography,Grid,TextField,InputLabel,Select,OutlinedInput,MenuItem,FormControl,Card,CardContent,CardHeader,CircularProgress} from '@mui/material';
import PropTypes from 'prop-types';
import unsplash from "../api/unsplash";
import moment from "moment";
import momentTimezone from "moment-timezone";

import "moment/locale/it";
import { DatePicker ,LocalizationProvider} from "@mui/lab";
import DateAdapter from '@mui/lab/AdapterMoment';

import {Euro,AttachFile,AccountCircle,Check,Engineering} from '@mui/icons-material';


const DettaglioMedici = () => {
    const location = useLocation();
    const [value, setValue] = useState(0);
    const [medicoCopy,setMedicoCopy] = useState(location.state.medico);
    const [medico,setMedico] = useState(location.state.medico);
    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
      }
    const handleChange = (e) => {
      let med = {...medico};
      med[e.target.name] = e.target.value;
      setMedico(med);
      }

    const handleSave = async() => {
        try{
            await unsplash.put('medici',{medico:medico},
            { headers: {
              'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
            }}  )
            alert("Dati lavoratore aggiornati con successo");
        }catch{

            alert("ERRORE NEL SALVATAGGIO");
        }


      }



return (

<>
<Grid item xs={12}>
<Card>
  <CardHeader sx={{textAlign:"center"}} title={medicoCopy.Nome+" "+medicoCopy.Cognome }  titleTypographyProps={{variant:'h4' }}/>
  </Card>
  <Card sx={{marginTop:"10px"}}>
  <CardContent>
   <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
     
          <Tabs value={value} textColor="inherit" variant="scrollable" onChange={handleChangeTab} aria-label="basic tabs example">
            <Tab icon={<AccountCircle/>} iconPosition="start" label="Generale" {...a11yProps(0)} />
            <Tab icon={<AttachFile />} iconPosition="start"  label="Allegati" {...a11yProps(1)} />
            <Tab icon={<Euro />} iconPosition="start" label="Fatturazione" {...a11yProps(2)} />
         
          </Tabs>
          </Box>
        <TabPanel value={value} index={0}>{/*GEnerale*/}
        { medico?    
  <Grid container spacing={2}>    
  <Grid item xs={12} md={6}>
  <TextField id="outlined-basic" label="Nome" value={medico.Nome} name="Nome" onChange={handleChange} fullWidth/>
  </Grid>
  <Grid item xs={12} md={6}>
  <TextField id="outlined-basic" label="Cognome" value={medico.Cognome} name="Cognome" onChange={handleChange} fullWidth/>
  </Grid>
  <Grid item xs={12} md={6}>
  <TextField id="outlined-basic" label="CF" value={medico.CF} name="CF" onChange={handleChange} fullWidth/>
  </Grid>
  <Grid item xs={12} md={6}>
  <TextField id="outlined-basic" label="Email" value={medico.eMail} name="eMail" onChange={handleChange} fullWidth/>
  </Grid>
  <Grid item xs={12} md={6}>
  <LocalizationProvider dateAdapter={DateAdapter}>
  <DatePicker

  ampmInClock={false}
    renderInput={(props) => <TextField {...props} fullWidth />}
    label="Data di Nascita"
    value={medico.DataDiNascita}
  />
</LocalizationProvider>
  </Grid>
 
  <Grid item xs={12} md={6}>
  <TextField id="outlined-basic" label="Luogo di Nascita" value={medico.Telefono} name="LuogoDiNascita" onChange={handleChange} fullWidth/>
  </Grid>


<Grid item xs={12} md={6}>
<Button variant="contained" startIcon={<Check />} onClick={handleSave}> Salva</Button>


</Grid>


</Grid> :<CircularProgress  color="primary"/>}
        
        </TabPanel>
        <TabPanel value={value} index={1}>{/*Protocollo sanitario*/}
        
   
        
        </TabPanel>
        <TabPanel value={value} index={2}>
       Fatturazione
        </TabPanel>
      </Box>
      </CardContent>
      </Card>
      </Grid>
      </>

)







}




function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  








export default DettaglioMedici